/* eslint func-names: 0 */
/* eslint no-multi-assign: 0 */
/* eslint consistent-return: 0 */
/* eslint no-cond-assign: 0 */

function isFunction(value) {
    return typeof value === 'function';
}

const pluses = /\+/g;
const isLocal = 'test';
const cookie = {};
const cookieConfig = cookie.set = cookie.get = (key, value, options) => {
    // Write
    let opts;

    if (value !== undefined && !isFunction(value)) {
        opts = Object.assign({}, options);

        if (typeof opts.expires === 'number') {
            const days = opts.expires;
            const t = (opts.expires = new Date());
            t.setDate(t.getDate() + days);
        }

        document.cookie = [
            encode(key),
            '=',
            stringifyCookieValue(value),
            // use expires attribute, max-age is not supported by IE
            opts.expires ? `; expires=${opts.expires.toUTCString()}` : '',
            opts.path ? `; path=${opts.path}` : '',
            opts.domain ? `; domain=${opts.domain}` : '',
            configureSecureFlag(opts.allowInsecure),
        ].join('');

        return document.cookie;
    }

    // Read

    let result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling Cookie().
    const cookies = document.cookie ? document.cookie.split('; ') : [];

    for (let i = 0, l = cookies.length; i < l; i += 1) {
        const parts = cookies[i].split('=');
        const name = decode(parts.shift());
        let cookieTemp = parts.join('=');

        if (key && key === name) {
            // If second argument (value) is a function it's a converter...
            result = read(cookieTemp, value);
            break;
        }

        // Prevent storing a cookie that we couldn't decode.
        if (!key && (cookieTemp = read(cookieTemp)) !== undefined) {
            result[name] = cookieTemp;
        }
    }

    return result;
};

// force cookies to have the secure attribute enabled by default
// except for the local environment
function configureSecureFlag(allowInsecure) {
    if (isLocal) {
        return '';
    }

    return allowInsecure ? '' : '; secure';
}

function encode(s) {
    return cookieConfig.raw ? s : encodeURIComponent(s);
}

function decode(s) {
    return cookieConfig.raw ? s : decodeURIComponent(s);
}

function stringifyCookieValue(value) {
    return encode(cookieConfig.json ? JSON.stringify(value) : String(value));
}

function parseCookieValue(value) {
    let s = value;
    if (s.indexOf('"') === 0) {
        // This is a quoted cookie as according to RFC2068, unescape...
        s = s
            .slice(1, -1)
            .replace(/\\"/g, '"')
            .replace(/\\\\/g, '\\');
    }

    try {
        // Replace server-side written pluses with spaces.
        // If we can't decode the cookie, ignore it, it's unusable.
        s = decodeURIComponent(s.replace(pluses, ' '));
    } catch (e) {
        return;
    }

    try {
        // If we can't parse the cookie, ignore it, it's unusable.
        return cookieConfig.json ? JSON.parse(s) : s;
    } catch (e) {
        throw e;
    }
}

function read(s, converter) {
    const value = cookieConfig.raw ? s : parseCookieValue(s);
    return isFunction(converter) ? converter(value) : value;
}

cookie.remove = (key, options) => {
    if (cookie.get(key) !== undefined) {
        // Must not alter options, thus extending a fresh object...
        cookie.set(key, '', Object.assign({}, options, { expires: -1 }));
        return true;
    }
    return false;
};

const Cookie = cookie;

export default Cookie;
